import _ from 'lodash';
import sassBreakpoints from 'sass/utils/_breakpoints.scss';

export const getBreakpoints = (): any => sassBreakpoints;

export const getBreakpointByName = (name: string): number => {
  const breakAt = _.get(sassBreakpoints, name, 0).toString();
  return parseInt(breakAt, 10);
};

export const getNameByPixels = (pixelSize: number): string|undefined => {
  let currentBreakpointName;

  // iterate through each of the breakpoints
  _.forIn(sassBreakpoints, (startsAt, breakPointName): void => {
    // check if current size is greater than min
    if (startsAt === 0 || pixelSize >= startsAt) {
      // if the current size is greater than the min (or 0 to catch mobile)
      currentBreakpointName = breakPointName;
    }
  });

  return currentBreakpointName;
};

export default {
  getBreakpoints,
  getBreakpointByName,
  getNameByPixels,
};
